import React, { FC, ReactNode } from 'react';
import { StyledDiv } from '~/layouts/MobileLayout/MobileLayout.styles';

export interface MobileLayoutProps {
  children: ReactNode;
}

const MobileLayout: FC<MobileLayoutProps> = ({ children }) => (
  <StyledDiv>
    {children}
  </StyledDiv>
);

export default MobileLayout;
